import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';


@Component({
    selector: 'app-post-text-getter-dialog',
    templateUrl: 'post-text-getter.component.html',
    styleUrls: ['./post-text-getter.component.scss']
})
export class PostTextGetterComponent {

    currentInfo: {
        text: string
    };

    @ViewChild('editorElement') editorElement: ElementRef;
    @ViewChild('sizeCalculationDiv') sizeCalculationDiv: ElementRef;

    constructor(
        private dialogRef: MatDialogRef<PostTextGetterComponent>,
        @Inject(MAT_DIALOG_DATA) public data
    ) {
        this.currentInfo = {
            text: ""
        };
        if (data.text) {
          this.currentInfo = {
            text: data.text
        };
        }
    }

    async apply() {
      let result;
        if (this.currentInfo.text && this.currentInfo.text !== "") {
          result = this.currentInfo;
        } else {
          result = {
            text: null
          }
        }
        this.dialogRef.close(result);
    }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/ng-components/post-text-getter/post-text-getter.component.ts